module.exports = __webpack_public_path__ + "img/glyphs-light.7ca028d2.png";